import { defineMessages } from 'react-intl';

/** The copy of Settings → Team → "What members can see" (design your-intelligence e4, §10). */
export const membersSeeEarningsMessages = defineMessages({
  title: { id: 'app.sml.team.membersSee.title', defaultMessage: 'What members can see' },
  label: { id: 'app.sml.team.membersSee.earnings', defaultMessage: 'Members can see earnings' },
  offText: {
    id: 'app.sml.team.membersSee.off',
    defaultMessage:
      'Only you see earnings and the Ditto balance. Members see streams, stores, countries and playlists.',
  },
  onText: {
    id: 'app.sml.team.membersSee.on',
    defaultMessage:
      'Every member of {workspace} sees net and gross earnings and the Ditto balance. No one sees bank or payout details in MUSIC24.',
  },
});
